import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  PaymentActionError,
  RegisterPaymentPayload,
  ResultAction,
} from '@cashier/cashier-model';

export interface PaymentRegistrationState {
  resultAction: ResultAction | null;
  error: PaymentActionError | null;
  isRegistrationLoading: boolean;
  isRegistrationSuccess: boolean;
  isRegistrationFailed: boolean;
}

export const PAYMENT_REGISTRATION_FEATURE_KEY = 'paymentRegistration';

export const initialPaymentRegistrationState: PaymentRegistrationState = {
  resultAction: null,
  error: null,
  isRegistrationLoading: false,
  isRegistrationFailed: false,
  isRegistrationSuccess: false,
};

export const paymentRegistrationSlice = createSlice({
  name: PAYMENT_REGISTRATION_FEATURE_KEY,
  initialState: initialPaymentRegistrationState,
  reducers: {
    resetRegistrationState: (state) => {
      state.resultAction = initialPaymentRegistrationState.resultAction;
      state.error = initialPaymentRegistrationState.error;
      state.isRegistrationLoading =
        initialPaymentRegistrationState.isRegistrationLoading;
      state.isRegistrationFailed =
        initialPaymentRegistrationState.isRegistrationFailed;
      state.isRegistrationSuccess =
        initialPaymentRegistrationState.isRegistrationSuccess;
    },
    registerPaymentStart: (
      state,
      action: PayloadAction<RegisterPaymentPayload>,
    ) => {
      state.isRegistrationLoading = true;
    },
    registrationPaymentSuccess: (
      state,
      action: PayloadAction<ResultAction>,
    ) => {
      state.resultAction = action.payload;
      state.isRegistrationLoading = false;
      state.isRegistrationSuccess = true;
      state.isRegistrationFailed = false;
    },
    registrationPaymentFailure: (
      state,
      action: PayloadAction<PaymentActionError>,
    ) => {
      state.error = action.payload;
      state.isRegistrationLoading = false;
      state.isRegistrationSuccess = false;
      state.isRegistrationFailed = true;
    },
  },
});

export const paymentRegistrationReducer = paymentRegistrationSlice.reducer;

export const {
  resetRegistrationState,
  registrationPaymentSuccess,
  registrationPaymentFailure,
  registerPaymentStart,
} = paymentRegistrationSlice.actions;
